export const PositionDirectionTypeEnum= Object.freeze({
    start: "start",
    middle: "middle",
    end: "end"
})